
<template lang="pug">
    .z-check-list(v-bind:class="{'inline': $props.inline}")
        label.list-label(v-if="$props.label") {{$props.label}}
        .z-check-list-items
            slot
</template>
<script>
    export default {
        name: 'z-check-list',
        props: {
            label: {
                type: String,
                default: ''
            },
            inline: {
                type: Boolean,
                default: false
            },
        },
        model: {},
        data() {
            return {}
        },
        created() {},
        watch: {},
        computed: {},
        methods: {}
    }
</script>
<style lang="sass">
    .z-check-list
        label.list-label
            display: block
            color: rgba(0, 0, 0, 0.54)
            font-size: 12px
            line-height: 12px
            margin: 0 0 10px 0
        .z-check-list-items
        &.inline
            .z-check-list-items
                display: flex
                flex-wrap: wrap
                align-items: flex-start
                justify-content: flex-start
            .z-check
                margin: 0 10px 10px 0
</style>


// WEBPACK FOOTER //
// ZCheckList.vue?78c0f827